if (document.getElementById('budgetTable')) {
  tableSortNameColumn();
}
function tableSortNameColumn() {
  document.addEventListener('DOMContentLoaded', function () {
    const table = document.getElementById('budgetTable');
    const headers = table.querySelectorAll('.sortable');
    let currentOrder = 'asc';

    headers.forEach((header) => {
      header.addEventListener('click', () => {
        const columnIndex = Array.from(header.parentNode.children).indexOf(header) + 1;
        currentOrder = currentOrder === 'asc' ? 'desc' : 'asc';
        sortTable(table, columnIndex, currentOrder);
        updateSortIcon(header, currentOrder);
      });
    });

    function sortTable(table, columnIndex, order) {
      const rows = Array.from(table.querySelectorAll('tbody tr:not(.total-row)'));
      const totalRow = table.querySelector('tbody .total-row');
      const isAsc = order === 'asc';

      rows.sort((a, b) => {
        const aText = a.querySelector(`td:nth-child(${columnIndex})`) ? a.querySelector(`td:nth-child(${columnIndex})`).innerText : '';
        const bText = b.querySelector(`td:nth-child(${columnIndex})`) ? b.querySelector(`td:nth-child(${columnIndex})`).innerText : '';

        return isAsc ? aText.localeCompare(bText) : bText.localeCompare(aText);
      });

      rows.forEach((row) => table.querySelector('tbody').appendChild(row));

      if (totalRow) {
        table.querySelector('tbody').appendChild(totalRow);
      }
    }

    function updateSortIcon(header, order) {
      headers.forEach((h) => {
        h.querySelector('.icon svg').style.transform = '';
      });

      const icon = header.querySelector('.icon svg');
      icon.style.transform = order === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)';
    }
  });
}
